module.exports = __webpack_public_path__ + "img/aomen7.741e5e4b.jpg";